<template>
  <div ref="widget" class="ui celled blue table"></div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    title: {
      type: String
    },
    category: {
      type: Object
    },
    columns: {
      type: Array
    },
    label: {
      type: Object
    },
    filename: {
      type: String,
      default: 'Export.xlsx'
    },
    dataSource: {
      type: [Object, Array]
    },
    format: {
      type: String,
      default: '{0:n2}'
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    autoheight: {
      type: Boolean
    },
    height: {
      type: Number,
      default: 340
    },
    editable: {
      type: String
    },
    pageable: {
      type: [Object, Boolean],
      default: () => ({
        refresh: true,
        pageSizes: true,
        buttonCount: 5
      })
    }
  },

  data () {
    const maxPageSize = 20;
    const lengthSource = _.size(this.dataSource.data || this.dataSource) > maxPageSize ? maxPageSize : _.size(this.dataSource.data || this.dataSource);
    const height = this.autoheight ? (35 * lengthSource) + 100 : this.height;

    const config = {
      theme: 'bootstrap',
      dataSource: {
        data: []
      },
      excel: {
        allPages: true,
        fileName: this.filename
      },
      scrollable: this.scrollable,
      selectable: 'multiple cell',
      allowCopy: true,
      sortable: true,
      reorderable: true,
      resizable: true,
      pageable: this.pageable,
      columns: this.columns,
      height: height
    };

    if (this.dataSource) {
      if (_.isArray(this.dataSource)) {
        config.dataSource.data = this.dataSource;
      } else {
        config.dataSource = this.dataSource;
      }
    }

    if (this.editable) {
      config.editable = this.editable;
    }

    return {
      config,
      widget: undefined,
      image: undefined
    };
  },

  methods: {
    exportTable () {
      this.widget.saveAsExcel();
    }
  },

  mounted () {
    this.widget = new kendo.ui.Grid(this.$refs.widget, this.config);
  },

  destroyed () {
    if (this.widget) {
      this.widget.destroy();
    }
  },

  watch: {
    dataSource (val) {
      let dataSource = {
        pageSize: 20
      };
      _.isArray(val) ? dataSource.data = val : dataSource = val;
      this.widget.setDataSource(new kendo.data.DataSource(dataSource));
    },

    category (newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        const categoryAxis = Object.assign({}, this.config.categoryAxis, {
          field: newVal.field
        });
        this.widget.setOptions({ categoryAxis });
      }
    },

    columns (newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        this.widget.setOptions({ columns: newVal });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
